import { useDispatch } from "react-redux";

import { baseApi } from "@services/api/baseApi";
import { setReloadSection } from "@store/slices/componentsSlice";

/**
 * Acción del botón "Recargar sección": invalida el caché compartido de la solicitud
 * (detalle, resumen y régimen fiscal) y avisa a las secciones montadas que recarguen su información.
 */
export function useReloadSection() {
    const dispatch = useDispatch();

    const reloadSection = () => {
        dispatch(baseApi.util.invalidateTags(["Application", "ApplicationResume", "TaxSystem"]));
        dispatch(setReloadSection(true));
    };

    return { reloadSection };
}
